// extracted by mini-css-extract-plugin
export var grey = "aboutUs-module--grey--17mxj";
export var generalContent = "aboutUs-module--general-content--mjfb_";
export var grid = "aboutUs-module--grid--3oOn-";
export var secondGeneralContent = "aboutUs-module--second-general-content--f7cu3";
export var largeCardsHeading = "aboutUs-module--large-cards-heading--39HrF";
export var whiteIce = "aboutUs-module--white-ice--1AwkV";
export var arrow = "aboutUs-module--arrow--1Jj6x";
export var leadershipGrid = "aboutUs-module--leadership-grid--3NbYd";
export var leadership = "aboutUs-module--leadership--1vV9-";
export var topSection = "aboutUs-module--top-section--h_Lda";
export var imageAdjust = "aboutUs-module--image-adjust--cr4VJ";
export var halfBleedOverride = "aboutUs-module--half-bleed-override--ABcek";